<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-dsjpt">
        <div class="cover-text">
          <h4>大数据平台</h4>
          <p class="info">作为一站式数据处理及分析平台，大数据平台以自有计算引擎为基础，深入智慧社区、智慧街道、市域社会治理等城市场景，一站式完成数据抽取、转换、共享、展现等，形成城市数据全生命周期管理体系。一方面使得城市场景具备敏捷应对、资源调度、智能预测的能力；另一方面，平台可在多个场景之间进行切换与赋能，能够放大城市场景数据资源的价值，进一步提升场景的安全性、高效性与便捷性。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/dsjpt/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">数据深度挖掘</div>
          </div>
          <div class="feature feature-two">
            <div class="text">数据反哺业务</div>
          </div>
          <div class="feature feature-three">
            <div class="text">多维业务聚合</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dsjpt",
  data() {
    return {
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ico_sjzl.png"),
          text: "数据治理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ico_sjaq.png"),
          text: "数据安全"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ico_rwdd.png"),
          text: "任务调度"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ico_sjfx.png"),
          text: "数据分析"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ico_sjks.png"),
          text: "数据可视"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/sqtp.png"),
          text: "社区图谱"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/ycjg.png"),
          text: "异常告警"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/clgs.png"),
          text: "车辆归属"
        },
        {
          imgUrl: require("@/assets/images/productInfo/dsjpt/sbls.png"),
          text: "设备流水"
        }
      ]
    };
  }
};
</script>
